/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { IonContent, IonHeader, IonTitle, IonToolbar, IonItem, IonLabel, IonSelect, IonSelectOption, IonModal, IonButton, IonIcon, IonButtons } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import { closeOutline } from 'ionicons/icons'
import { useUnitSystem, Language, useLanguage, useCholesterolUnit, CholesterolUnit, UnitSystem } from '../utils/Settings';

interface SettingsProps {
  show: boolean;
  onClose: () => void
};

const Settings: React.FC<SettingsProps> = ({ show, onClose }) => {

  const [t] = useTranslation();
  const [language, setLanguage] = useLanguage();
  const [unitSystem, setUnitSystem] = useUnitSystem();
  const [cholesterolUnit, setCholesterolUnit] = useCholesterolUnit();

  return (
    <IonModal
      isOpen={show}
      swipeToClose={true}
      keyboardClose={true}
      onDidDismiss={onClose}>
      <IonHeader>
        <IonToolbar>
          <IonTitle>{t('Settings')}</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={onClose}>
              <IonIcon slot="icon-only" icon={closeOutline}></IonIcon>
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonItem>
          <IonLabel>{t('Language')}</IonLabel>
          <IonSelect interface="popover" value={language} onIonChange={e => setLanguage(e.detail.value)}>
            <IonSelectOption key={Language.English} value={Language.English}>English</IonSelectOption>
            <IonSelectOption key={Language.Spanish} value={Language.Spanish}>Español</IonSelectOption>
            <IonSelectOption key={Language.Portuguese} value={Language.Portuguese}>Português</IonSelectOption>
          </IonSelect>
        </IonItem>
        <IonItem>
          <IonLabel>{t('Unit system')}</IonLabel>
          <IonSelect interface="popover" value={unitSystem} onIonChange={e => setUnitSystem(e.detail.value)}>
            <IonSelectOption key={UnitSystem.Imperial} value={UnitSystem.Imperial}>{t('Imperial')}</IonSelectOption>
            <IonSelectOption key={UnitSystem.Metric} value={UnitSystem.Metric}>{t('Metric')}</IonSelectOption>
          </IonSelect>
        </IonItem>
        <IonItem>
          <IonLabel>{t('Cholesterol unit')}</IonLabel>
          <IonSelect interface="popover" value={cholesterolUnit} onIonChange={e => setCholesterolUnit(e.detail.value)}>
            <IonSelectOption key={CholesterolUnit.mgdl} value={CholesterolUnit.mgdl}>mg/dl</IonSelectOption>
            <IonSelectOption key={CholesterolUnit.mmol} value={CholesterolUnit.mmol}>mmol/L</IonSelectOption>
          </IonSelect>
        </IonItem>
      </IonContent>
    </IonModal>
  );
};

export default Settings;
